export function UploadZone({ onPick }) {
  return (
    <div
      id="uploadZone"
      onClick={onPick}
      onKeyDown={(e) => e.key === 'Enter' && onPick()}
      role="button"
      tabIndex={0}
    >
      <div className="upload-icon">📂</div>
      <div className="upload-title">Importer le fichier CSV de suivi du temps</div>
    </div>
  );
}


